export const resolveABLink = async (url: string): Promise<string> => {
  try {
    if (!isABLink(url)) {
      return url;
    }
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(
        `Failed to resolve ABLink: ${response.status} ${response.statusText}`,
      );
    }
    return response.url;
  } catch {
    throw new Error(`Error resolving ABLink.`);
  }
};

export const isABLink = (url: string): boolean => {
  return url.startsWith('https://ablink.bank.varomoney.com') ? true : false;
};
